//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../lib/date';

export default {
    name: 'deliveryPlans',
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        var vm = this;
        return {
            loading: false,
            saving: false,
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            searchInput: {},
            list: [],
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '名称', align: 'center',
                    key: 'name',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showDeliveryPlan(row);
                                }
                            }
                        }, row.name));
                        return h('div', actions);
                    }
                },
                {
                    title: '城市名称', align: 'center',
                    key: 'cityName'
                },
                {
                    title: '项目名称', align: 'center',
                    key: 'projectName'
                },
                {
                    title: '交付批次', align: 'center',
                    key: 'batch'
                },
                // {
                //     title: '分期名称', align: 'center',
                //     key: 'projectStages'
                // },
                // {
                //     title: '楼栋号', align: 'center',
                //     key: 'roomStructureName'
                // },
                {
                    title: '状态', align: 'center',
                    key: 'statusStr'
                },
                {
                    title: '开放预约日期', align: 'center', width: 210,
                    render: (h, params) => {
                        const row = params.row;
                        if (row.appointmentStartTimeStr) {
                            return h('span', row.appointmentStartTimeStr + '-' + row.appointmentEndTimeStr);
                        } else {
                            return h('span', '');
                        }

                        // let row = params.row;
                        // let actions = [];
                        // actions.push(h('p', '开始时间:' + row.appointmentStartTimeStr));
                        // actions.push(h('p', '结束时间:' + row.appointmentEndTimeStr));
                        // return h('div', actions);
                    }
                },
                {
                    title: '交付日期', align: 'center', width: 210,
                    render: (h, params) => {
                        const row = params.row;
                        // if (row.deliveryStartTimeStr && row.deliveryEndTimeStr) {
                        //     return h('span', row.deliveryStartTimeStr + '—' + row.deliveryEndTimeStr);
                        // } else {
                        //     return h('span', '');
                        // }
                        let actions = [];
                        actions.push(h('p', row.deliveryStartTimeStr + '-' + row.deliveryEndTimeStr));
                        actions.push(h('p', row.startTime + '-' + row.endTime));
                        return h('div', actions);
                    }
                }
                // {
                //     title: '操作', align: 'center',
                //     render: (h, params) => {
                //         const row = params.row;
                //         const actions = [];
                //
                //         var delBtn = h('Button', {
                //             props: {
                //                 type: 'error',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.delDeliveryPlan(params.row);
                //                 }
                //             }
                //         }, '删除');
                //
                //         var editBtn = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.showEdit(params.row);
                //                 }
                //             }
                //         }, '编辑');
                //
                //         var approveBtn = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.approve(params.row);
                //                 }
                //             }
                //         }, '审核');
                //
                //         var detailBtn = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.showDeliveryPlan(params.row);
                //                 }
                //             }
                //         }, '查看');
                //
                //         var cancelAuditBtn = h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.cancelAudit(params.row);
                //                 }
                //             }
                //         }, '取消审核');
                //
                //         if (row.status == 0) {
                //             actions.push(approveBtn);
                //             actions.push(editBtn);
                //             actions.push(delBtn);
                //         } else {
                //             // actions.push(detailBtn);
                //             actions.push(cancelAuditBtn);
                //
                //         }
                //
                //
                //         return h('div', actions);
                //     }
                // }
            ],
            showDeliveryPlanEditModal: false,
            deliveryPlan: {},
            rules: {
                name: [{ required: true, message: '请输入计划名称', trigger: 'blur' }],
                cityId: [{ required: true, type: 'number', message: '请选择城市', trigger: 'change' }],
                projectId: [{ required: true, type: 'number', message: '请选择项目', trigger: 'change' }],
                projectStages: [{ required: true, message: '请选择分期', trigger: 'change' }],
                roomStructureName: [{ required: true, message: '请选择楼栋', trigger: 'change' }],
                dailyNumber: [{ required: true, type: 'number', message: '请输入每天人数限制', trigger: 'blur' }],
                hourlyNumber: [{ required: true, type: 'number', message: '请输入每小时人数限制', trigger: 'blur' }],
                deliveryStartTime: [{ required: true, message: '请选择交付开始时间', trigger: 'change' }],
                deliveryEndTime: [{ required: true, message: '请选择交付结束时间', trigger: 'change' }],
                appointmentStartTime: [{ required: true, message: '请选择预约开始时间', trigger: 'change' }],
                appointmentEndTime: [{ required: true, message: '请选择预约结束时间', trigger: 'change' }]
            },
            title: '',
            projects: [],
            cityList: [],
            stages: [],
            loudongs: [],
            projectStages: '',
            selectProjectId: 0,
            showDeliveryPlanModal: false,
            deliveryDate: [],
            time: [],
            roomStructureName: [],
            showTreeModal: false,
            data1: [],
            dranges: []
        };
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('project/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('project/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            abp.ajax.post('/api/services/app/Delivery/SearchDeliveryPlans', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
                // this.getCounts();
            }).finally(() => {
                this.loading = false;
            });
        },
        showEdit(d) {
            // this.deliveryPlan = {};
            // this.$refs.deliveryPlanForm.resetFields();
            // this.deliveryPlan = JSON.parse(JSON.stringify(d));
            // this.deliveryDate = [];
            // this.time = [];
            // this.roomStructureName = [];
            // if (this.deliveryPlan.id > 0) {
            //     this.title = '编辑计划';
            //     var select = this.cityList.filter(x => x.id === parseInt(this.deliveryPlan.cityId));
            //     this.projects = select[0].projects;
            //     // this.projectStages = this.deliveryPlan.projectStages;
            //     this.selectProjectId = this.deliveryPlan.projectId;
            //
            //     this.deliveryDate.push(this.deliveryPlan.deliveryStartTimeStr);
            //     this.deliveryDate.push(this.deliveryPlan.deliveryEndTimeStr);
            //     this.time.push(this.deliveryPlan.startTime);
            //     this.time.push(this.deliveryPlan.endTime);
            //     // if (this.deliveryPlan.roomStructureName.length > 0) {
            //     //     this.roomStructureName = this.deliveryPlan.roomStructureName.split(',');
            //     // }
            //     console.log(this.deliveryPlan.deliveryRang);
            //     this.dranges = [];
            //     this.dranges = JSON.parse(this.deliveryPlan.deliveryRange);
            //
            // } else {
            //     this.title = '新增计划';
            // }
            // this.showDeliveryPlanEditModal = true;

            this.$router.push({
                name: 'deliveryPlanEdit', params: {
                    planId: d.id
                }
            });
        },
        cancel() {
            this.showDeliveryPlanEditModal = false;
        },
        onSave() {
            console.log(this.deliveryPlan);
            // this.deliveryPlan.roomStructureName = this.roomStructureName.toString();
            if (!this.dranges.length > 0) {
                abp.message.warn('请选择交付范围');
                return;
            }
            if (!this.deliveryPlan.deliveryStartTime) {
                abp.message.warn('请选择交付日期');
                return;
            }

            if (!this.deliveryPlan.deliveryEndTime) {
                abp.message.warn('请选择交付日期');
                return;
            }

            if (!this.deliveryPlan.startTime) {
                abp.message.warn('请选择交付时段');
                return;
            }

            if (!this.deliveryPlan.endTime) {
                abp.message.warn('请选择交付时段');
                return;
            }

            this.deliveryPlan.deliveryRange = JSON.stringify(this.dranges);
            this.$refs.deliveryPlanForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Delivery/SaveDeliveryPlan', this.deliveryPlan).then(() => {
                        this.showDeliveryPlanEditModal = false;
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        getCities() {
            this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
                this.cityList = this.$store.state.city.cityList;
            });
        },
        cityOnChange(data) {
            var vm = this;
            vm.deliveryPlan.projectId = 0;
            vm.deliveryPlan.projectName = '';
            this.projects = [];
            vm.stages = [];
            // vm.$refs.stageSelectRef.clearSingleSelect();

            if (data) {
                vm.deliveryPlan.cityId = data.value;
                vm.deliveryPlan.cityName = data.label;
                vm.deliveryPlan.cityName = vm.deliveryPlan.cityName.replace(/\ +/g, '');
                vm.deliveryPlan.cityName = vm.deliveryPlan.cityName.replace(/[\r\n]/g, '');
                var select = this.cityList.filter(x => x.id === parseInt(this.deliveryPlan.cityId));
                this.projects = select[0].projects;
                // vm.getProjects(this.workOrder.cityId);
            }
        },
        onProjectChange(data) {
            const vm = this;
            // vm.deliveryPlan.roomId = 0;
            // vm.deliveryPlan.roomNum = '';
            vm.stages = [];
            // vm.$refs.stageSelectRef.clearSingleSelect();
            if (data) {
                vm.deliveryPlan.projectId = data.value;
                vm.deliveryPlan.projectName = data.label;
                vm.deliveryPlan.projectName = vm.deliveryPlan.projectName.replace(/\ +/g, '');
                vm.deliveryPlan.projectName = vm.deliveryPlan.projectName.replace(/[\r\n]/g, '');
                vm.getProjectStages(vm.deliveryPlan.projectId);
                this.selectProjectId = vm.deliveryPlan.projectId;
            } else {
                vm.deliveryPlan.projectId = 0;
                vm.deliveryPlan.projectName = '';
            }
        },
        onStageChange(data) {
            console.log(data);
            var vm = this;
            vm.loudongs = [];
            vm.$refs.loudongsRef.clearSingleSelect();
            if (data) {
                this.deliveryPlan.projectStages = data.label;
                vm.deliveryPlan.projectStages = vm.deliveryPlan.projectStages.replace(/\ +/g, '');
                vm.deliveryPlan.projectStages = vm.deliveryPlan.projectStages.replace(/[\r\n]/g, '');
                this.getLoudong(this.selectProjectId, vm.deliveryPlan.projectStages);
            }
        },
        onStageClear() {
            var vm = this;
            vm.loudongs = [];
            vm.$refs.loudongsRef.clearSingleSelect();
        },
        deliveryStartTimeChange(date) {

            this.deliveryPlan.deliveryStartTime = date;
        },
        deliveryEndTimeChange(date) {
            this.deliveryPlan.deliveryEndTime = date;
        },
        appointmentStartTimeChange(date) {
            this.deliveryPlan.appointmentStartTime = date;
            this.deliveryPlan.appointmentStartTimeStr = date;
        },
        appointmentEndTimeChange(date) {
            this.deliveryPlan.appointmentEndTime = date;
            this.deliveryPlan.appointmentEndTimeStr = date;
        },
        getProjectStages(projectId) {
            abp.ajax.get('/api/services/app/Project/GetProjectStages?projectId=' + projectId).then(res => {
                this.stages = [];
                this.stages.push(...res.data.result.items);
            });
        },
        getLoudong(projectId, fenqiName) {
            abp.ajax.get('/api/services/app/Project/GetLouDong?projectId=' + projectId + '&fenqiName=' + fenqiName).then(res => {
                this.loudongs = [];
                this.loudongs.push(...res.data.result);
            });
        },
        approve(row) {
            abp.ajax.post('/api/services/app/Delivery/Approve?id=' + row.id).then(() => {
                // this.showDeliveryPlanEditModal = false;
                this.getPage();
            }).finally(() => {
                this.saving = false;
            });
        },
        cancelAudit(row) {
            abp.ajax.post('/api/services/app/Delivery/CancelAudit?id=' + row.id).then(() => {
                // this.showDeliveryPlanEditModal = false;
                this.getPage();
            }).finally(() => {
                this.saving = false;
            });
        },
        showDeliveryPlan(d) {
            // this.deliveryPlan = {};
            // // this.$refs.deliveryPlanForm.resetFields();
            // this.deliveryPlan = JSON.parse(JSON.stringify(d));
            // this.dranges = [];
            // this.dranges = JSON.parse(this.deliveryPlan.deliveryRange);
            // this.showDeliveryPlanModal = true;

            this.$router.push({
                name: 'deliveryPlanInfo',
                params: {
                    planId: d.id
                }
            });
        },
        deliveryDateChange(date) {
            console.log(date);
            this.deliveryPlan.deliveryStartTime = date[0];
            this.deliveryPlan.deliveryEndTime = date[1];
        },
        timeChange(time) {
            console.log(time);
            this.deliveryPlan.startTime = time[0];
            this.deliveryPlan.endTime = time[1];
        },
        showTree() {
            if (this.deliveryPlan.projectId > 0) {
                this.getStagingBuildings(this.deliveryPlan.projectId);
            } else {
                abp.message.warn('请选择项目');
            }

        },
        onTreeSelect() {
            console.log(this.$refs.deliveryPlanRef.getCheckedNodes());
            var list = this.$refs.deliveryPlanRef.getCheckedNodes();
            var s1 = list.filter(x => x.type != 'ProjectStages');
            console.log(s1);
            this.dranges = [];
            for (var i = 0; i < s1.length; i++) {
                var s = s1[i].projectStages + '-' + s1[i].key;
                this.dranges.push(s);
            }
            console.log(this.dranges);
            this.showTreeModal = false;
        },
        delDeliveryPlan(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    abp.ajax.delete('/api/services/app/Delivery/Delete?id=' + row.id).then(() => {
                        // this.showDeliveryPlanEditModal = false;
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        getStagingBuildings(projectId) {
            abp.ajax.get('/api/services/app/Project/GetStagingBuildings?projectId=' + projectId).then(res => {
                this.data1 = [];
                this.data1.push(...res.data.result);
                this.showTreeModal = true;
            }).finally(() => {
                this.saving = false;
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }

    },
    created() {
        this.getPage();
        this.getCities();
    }
};
